export default "__VITE_ASSET__BeDsTwRB__"